import { Box, Typography } from "@mui/material";
import Signup from "./SignUp";
import Login from "./LogIn";
import Logout from "./LogOut";
import Profile from "./ProfileButton";
import NotificationBell from "./NotificationBell";
import SyncQuota from "./SyncQuota";
import { useNavigate } from "react-router-dom";
import SearchBar from "./SearchBar";
import { useAuth } from "../../../services/auth";
import { colors } from "../../../theme";

interface HeaderProps {
    enableSearch?: boolean;
}

export const HEADER_HEIGHT = 72;

export default function Header(props: HeaderProps) {
    const { enableSearch } = props;
    const navigate = useNavigate();
    // Read from shared auth state rather than a prop - callers used to hardcode
    // isLoggedIn={true}, so logging out left the header still showing a signed-in
    // user until a manual refresh.
    const { isLoggedIn, username } = useAuth();

    return (
        <Box
            component="header"
            sx={{
                height: HEADER_HEIGHT,
                px: { xs: 2, md: 3 },
                display: "flex",
                alignItems: "center",
                gap: 2,
                backgroundColor: colors.sidebar,
                borderBottom: `1px solid ${colors.line}`,
            }}
        >
            <Box
                onClick={() => navigate(isLoggedIn ? "/dashboard" : "/")}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    flexShrink: 0,
                    transition: "opacity 120ms ease",
                    "&:hover": { opacity: 0.85 },
                }}
            >
                <Box
                    component="img"
                    src="/assets/Shufl.png"
                    alt="Shufl"
                    sx={{ height: 40, width: "auto", display: "block" }}
                />
            </Box>

            {enableSearch && (
                <Box sx={{ flex: "0 1 380px", ml: { xs: 1, md: 3 }, display: { xs: "none", sm: "block" } }}>
                    <SearchBar />
                </Box>
            )}

            <Box sx={{ flexGrow: 1 }} />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
                {!isLoggedIn ? (
                    <>
                        <Login />
                        <Signup />
                    </>
                ) : (
                    <>
                        <SyncQuota />
                        <NotificationBell />
                        <Logout />
                        {username && (
                            <Typography
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: colors.textPrimary,
                                    maxWidth: 160,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: { xs: "none", sm: "block" },
                                }}
                            >
                                {username}
                            </Typography>
                        )}
                        <Profile />
                    </>
                )}
            </Box>
        </Box>
    );
}
